import React, { useEffect, useState, useRef } from 'react';
import { get, isEmpty, groupBy } from 'lodash';
import { useParams, Link } from 'react-router-dom';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import {
  studentMemberList,
  studentDiscussionFetch,
} from '../../../actions/digitalDoubtActions';
import { insertQuestionItem } from '../../../actions/teacherDigitalDoubtActions';

// Material Imports
import {
  Grid,
  makeStyles,
  // Button,
  // FormControl,
  // MenuItem,
  // TextField,
  // Card,
} from '@material-ui/core';
// Style Import
import './styles.scss';
// Icons
// import FilterIcon from 'app/assets/images/svg/filter';
// Global Components
import PopUpModal from '../../../components/PopUpModal';
// Components
import QuestionCard from '../components/QuestionCard';
import QuestionSubmitForm from '../components/QuestionSubmitForm';
import DoubtComments from '../DoubtComments';
import PageHeading from '../../../components/PageHeading';
import { Skeleton } from '@material-ui/lab';
////SignalR
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { HUB_BASE_URL } from '../../../api/fetch';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default function DoubtQuestions() {
  const classes = useStyles();
  const childRef = useRef();
  const commentRef = useRef();
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [videoFile, setVideoFile] = useState('');
  const [checked] = useState('All Doubts');
  const [commentQuestionCode, setCommentQuestionCode] = useState('');
  const [questionId, setQuestionId] = useState('');
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [conn, setConn] = React.useState(null);


  // Redux
  // const questionListData = useSelector((state) =>
  //   get(state, 'digitalDoubtReducer.questionList.listQuestion', [])
  // );
  const questionList = useSelector((state) =>
    get(state, 'digitalDoubtReducer.questionList', {})
  );

  var selfModelData = useSelector(state =>
    get( state, 'digitalDoubtReducer.questionList.selfModel', [], ),
  );
  var questionListData = useSelector(state =>
      get(state, 'digitalDoubtReducer.questionList.listMember', [],),
    );
  

  // const doubtTopics = useSelector((state) =>
  //   get(state, 'digitalDoubtReducer.doubtTopics.listSubject', [])
  // );
  const dispatch = useDispatch();
  const jwt = useSelector((state) => get(state, 'loginReducer.data.jwt', ''));
  const userId = useSelector(state => get(state, 'loginReducer.data.UserID', ''));
  const userType = useSelector((state) =>
    get(state, 'loginReducer.userType', '')
  );
  const profileImage = useSelector((state) =>
    get(state, 'loginReducer.data.profile[0].StudentPic', '')
  );
  const { forumCode, forumId} = useParams();


  useEffect(() => {
    setIsFetching(true);
    studentDiscussionFetch(jwt, dispatch);
    studentMemberList(forumCode, jwt, dispatch).then(() => {
      displaySelfModel();
      populateQuestionList();
      setIsFetching(false);
    });
  }, [forumCode]);

  // function cleanup() {
  //   clearInterval(loop);
  // }


 // Initialize the hub endpoint and set up routes for incoming events
 useEffect(() => {
   console.log(forumId)
  setTimeout(() => {
  const url_endpoint = `${HUB_BASE_URL}${
    userType === 'student' ? 2 : 1
  }&forumID=${parseInt(forumId, 10)}&token=${jwt}`;
  console.log('url_endpoint: $' + url_endpoint);
  const connection = new HubConnectionBuilder()
    .withUrl(url_endpoint,{
      withCredentials:false
    })
    .configureLogging(LogLevel.Debug)
    .build();
  console.log(`url_endpoint: ${url_endpoint}`),
    connection
      .start()
      .then(() => {
        console.log('connected');
      })
      .catch(
        err =>
          console.log(`Error starting the connection: ${err.toString()}`),
      );
      

  //   // Incoming messages will grow the message log array
  connection.on('addChatRoom', data => {
    console.log("onReceived"+JSON.stringify(data))
    const receivedValue = JSON.parse(JSON.stringify(data));
    const convertedValue = {
      DiscussionDetail: receivedValue.discussionDetail,
      ForumCode: receivedValue.forumCode,
      ForumTitle: receivedValue.forumTitle,
      IsClose: receivedValue.isClose,
      IsHide: receivedValue.isHide,
      IsSelfPost: userId==receivedValue.userID,
      LastVisit: receivedValue.lastVisit,
      PostBy: receivedValue.postBy,
      PostTime: receivedValue.postTime,
      QuestionCode: receivedValue.questionCode,
      QuestionDate: receivedValue.questionDate,
      QuestionDetail: receivedValue.questionDetail,
      QuestionID: receivedValue.questionID,
      QuestionImage: receivedValue.questionImage,
      QuestionTitle: receivedValue.questionTitle,
      TotalComment: receivedValue.totalComment,
      TotalCommentUnread: receivedValue.totalCommentUnread,
      UserType: receivedValue.userType,
      VideoURL: receivedValue.videoURL,
      listDiscussion: receivedValue.listDiscussion,
    };
    console.log(' without received' + convertedValue);
      insertQuestionItem(convertedValue, dispatch);
  });
  connection.on('onError', data => {
    console.log('ERROR=>' + data);
  });

  // Handle connection closing
  connection.onclose(async () => {
      connection.start()

  });

  setConn(connection);
  }, 1000);
}, []);


function questionHubData(sendQuestion) {
  console.log(sendQuestion);
  
  conn
    .invoke('CreateRoom', `${sendQuestion}`)
    .then(response => {
      console.log(
        'direct-response-from-server',
        response + '>>>>>>>>>>>>>>>>>>>>>>>' + sendQuestion,
        
      );
    })
    .catch(err => {
      console.log(err);
    });
}


  const onRefresh = React.useCallback(() => {
    setIsFetching(true);
    studentMemberList(forumCode, jwt, dispatch).then(() => {
      displaySelfModel();
      populateQuestionList();
      setIsFetching(false);
    });
  }, [isFetching]);

  useEffect(() => {
    displaySelfModel();
    populateQuestionList();
  }, [checked]);

  // const handleChange = (event) => {
  //   setChecked(event.target.value);
  // };

  const handlePopupOpen = (e, isApproved, isHide) => {
    const component =
      !isEmpty(e.target) && !isEmpty(e.target.getAttribute('name'))
        ? e.target.getAttribute('name')
        : '';
    component !== 'image' &&
      component !== 'video' &&
      component !== 'bookmark' &&
      !isHide &&
      commentRef.current.handleClickOpen();
  };

  const displaySelfModel = () => {
    // let whenLoading = [1, 1, 1, 1];
    // (isFetching 
    //   ? whenLoading 
    //   : (selfModelData)
    //   );

    if(!isFetching && selfModelData != undefined)
    {
      const data = selfModelData;
      
      return <div className="forum-list mt-20">
        <QuestionCard
          PostBy={data.MemberFullName}
          PostByPicture={data.PictureURL}
          PostTime={data.LastPostTime}
          TotalComment={data.TotalComment}
          IsClose={data.IsClose}
          listComment={data.listComment}
          UserType={data.UserType}
          IsSelfPost={data.IsSelfPost}
          key={data.DFMID}
          isFetching={isFetching}
          QuestionTitle={data.QuestionTitle}
          QuestionDetail={data.QuestionDetail}
          QuestionImage={data.QuestionImage}
          QuestionCode={data.QuestionCode}
          DiscussionDetail={data.DiscussionDetail}
          UnreadComment={data.UnreadComment}
          TotalCommentUnread={data.TotalCommentUnread}
          IsApproved={data.IsApproved}
          IsReject={data.IsReject}
          IsHide={data.IsHide}
          QuestionID={data.QuestionID}
          IsBookMarked={data.IsBookMarked}
          MobileContact={data.MobileContact}
          VideoURL={data.VideoURL}
          jwtToken={jwt}
          forumCode={forumCode}
          // dispatch={dispatch}
          userType={userType}
          questionCode={data.QuestionCode}
          selectedQuestion={selectedQuestion}
          IsSelfModel={true}
          onClick={(e) => {
            handlePopupOpen(e, data.IsApproved, data.IsHide);
            if (!data.IsHide) {
              setCommentQuestionCode(data.QuestionCode);
              setQuestionId(data.QuestionID)
              setSelectedQuestion({
                QuestionTitle: data.QuestionTitle,
                QuestionDetail: data.QuestionDetail,
                QuestionImage: data.QuestionImage,
                QuestionCode: data.QuestionCode,
                PostBy: data.PostBy,
                MemberFullName: data.MemberFullName,
                PostByPicture: data.PostByPicture,
                PostTime: data.PostTime,
                VideoURL: data.VideoURL,
                IsSelfPost: questionList.DFMID,
                IsApproved: data.IsApproved,
                IsReject: data.IsReject,
                IsHide: data.IsHide,
                IsClose: data.IsClose,
                userType: userType,
                DFDID: data.DFDID,
                DFMID: data.DFMID,
                BatchId: data.BatchId,
                });
              }
            }}
        />
      </div>
    }
  };

  const populateQuestionList = () => {
    const list = [];
    let whenLoading = [1, 1, 1, 1];
    (isFetching ? whenLoading : questionListData).map((data) => {
      //Chandan
      if (
        data.IsSelfPost ||
        !data.IsHide ||
        isFetching
      ) {
        if (
          checked === 'All Doubts' ||
          (checked === 'Bookmarked Doubts' && data.IsBookMarked) ||
          (checked === 'My Doubts' && data.IsSelfPost) ||
          isFetching
        ) {
          return list.push(
            <QuestionCard
              PostBy={data.MemberFullName}
              PostByPicture={data.PictureURL}
              PostTime={data.LastPostTime}
              TotalComment={data.TotalComment}
              IsClose={data.IsClose}
              listComment={data.listComment}
              UserType={data.UserType}
              IsSelfPost={data.IsSelfPost}
              key={data.DFMID}
              isFetching={isFetching}
              QuestionTitle={data.QuestionTitle}
              QuestionDetail={data.QuestionDetail}
              QuestionImage={data.QuestionImage}
              QuestionCode={data.QuestionCode}
              DiscussionDetail={data.DiscussionDetail}
              UnreadComment={data.UnreadComment}
              TotalCommentUnread={data.TotalCommentUnread}
              IsApproved={data.IsApproved}
              IsReject={data.IsReject}
              IsHide={data.IsHide}
              QuestionID={data.QuestionID}
              IsBookMarked={data.IsBookMarked}
              MobileContact={data.MobileContact}
              VideoURL={data.VideoURL}
              jwtToken={jwt}
              forumCode={forumCode}
              //dispatch={dispatch}
              userType={userType}
              questionCode={data.QuestionCode}
              selectedQuestion={selectedQuestion}
              IsSelfModel={false}
              // reloadPage={() => onRefresh()}
              onClick={(e) => {
                handlePopupOpen(e, data.IsApproved, data.IsHide);
                if (!data.IsHide) {
                  setCommentQuestionCode(data.QuestionCode);
                  setQuestionId(data.QuestionID)
                  setSelectedQuestion({
                    QuestionTitle: data.QuestionTitle,
                    QuestionDetail: data.QuestionDetail,
                    QuestionImage: data.QuestionImage,
                    QuestionCode: data.QuestionCode,
                    PostBy: data.PostBy,
                    MemberFullName: data.MemberFullName,
                    PostByPicture: data.PostByPicture,
                    PostTime: data.PostTime,
                    VideoURL: data.VideoURL,
                    IsSelfPost: questionList.DFMID,
                    IsApproved: data.IsApproved,
                    IsReject: data.IsReject,
                    IsHide: data.IsHide,
                    IsClose: data.IsClose,
                    userType: userType,
                    DFDID: data.DFDID,
                    DFMID: data.DFMID,
                    BatchId: data.BatchId,
                    });
                  }
                }}
            />
          );
        }
      }
    });

    return <div className="forum-list mt-20">{list}</div>;
  };

  // const populateOtherDoubts = () => {
  //   let selectedSubject = questionList.SubjectName;
  //   let list = [];
  //   let whenLoading = [1, 1, 1, 1];
  //   (isFetching ? whenLoading : doubtTopics).map((data) => {
  //     if (isFetching) {
  //       list.push(
  //         <div className="item">
  //           <p className="sub-text mb-5">
  //             <Skeleton variant="text" width={'50%'} />
  //           </p>
  //           <p className="topic ">
  //             <Skeleton variant="text" width={'60%'} />
  //           </p>
  //         </div>
  //       );
  //     } else if (data.SubjectName === selectedSubject) {
  //       data.listForum.map((topicData, classIndex) => {
  //         list.push(
  //           <div className="item" key={classIndex}>
  //             <p className="sub-text mb-5">
  //               Doubt Asked: {topicData.TotalQuestion}
  //             </p>
  //             <p className="topic">
  //               <Link to={`/digital-doubt-counter`}>
  //                 {topicData.ForumTitle}
  //               </Link>
  //             </p>
  //           </div>
  //         );
  //       });
  //     }
  //   });
  //   return <div className="flex-column">{list}</div>;
  // };

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Digital Doubt" titleSecondary="Counter" />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={9} className="doubt-details">
          <div className="ddc-header" >
            <div className="title-header">
              <div style={{display: "flex"}}>
                <h3 className="topic" >
                  <Link to={`/digital-doubt-counter`}>
                    {"Doubt Counter >"}
                  </Link>
                </h3>
                  
                  <h3 className="forum-title" style={{marginLeft: 5}}>
                    {isFetching ? (
                      <Skeleton variant="text" width={200} />
                    ) : (
                        ` ${questionList.SubjectName} | ${questionList.ForumTitle}`
                      )}
                  </h3>
              </div>
              <div className="filter-subtitle">
                {isFetching ? (
                  <Skeleton variant="text" width={100} />
                ) : (
                    !isEmpty(questionListData) &&
                    (checked === 'All Doubts'
                      ? `All Doubts: ${questionListData.length}`
                      : checked === 'Bookmarked Doubts'
                        ? `Bookmarked Doubts: ${!isEmpty(groupBy(questionListData, { IsBookMarked: true }).true)
                          ? groupBy(questionListData, { IsBookMarked: true }).true.length
                          : '0'
                        }`
                        : `My Doubts: ${!isEmpty(groupBy(questionListData, { IsSelfPost: true }).true)
                          ? groupBy(questionListData, { IsSelfPost: true }).true.length
                          : '0'
                        }`)
                  )}
              </div>
            </div>
            {/* <div className="flex-row align-center">
              <FormControl variant="outlined">
                <TextField
                  select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={checked}
                  onChange={handleChange}
                  label="Age"
                  margin="dense"
                  InputLabel={false}
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  className="custom-select"
                >
                  <MenuItem value="My Doubts">My Doubts</MenuItem>
                  <MenuItem value="Bookmarked Doubts">
                    Bookmarked Doubts
                  </MenuItem>
                  <MenuItem value="All Doubts">All Doubts</MenuItem>
                </TextField>
              </FormControl>
              <div className="ml-10">
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={() => childRef.current.handleClickOpen()}
                >
                  Create New Doubt
                </Button>
              </div> */}
            {/* </div> */}
          </div>
          
          {selfModelData != undefined
           ? displaySelfModel()
           : null
           }
          { questionListData && questionListData.length > 0
            ? populateQuestionList()
            : null
          }
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          {/* <div className="doubt-details">
            <h3>
              Other Doubts
              <span className="small"> ({questionList.SubjectName})</span>
            </h3>

            <Card className="card chapter-card list-wrapper">
              {populateOtherDoubts()}
            </Card>
          </div> */}
        </Grid>
      </Grid>
      <PopUpModal
        ref={childRef}
        header="Create New Doubt"
        body={
          <QuestionSubmitForm
            forumCode={forumCode}
            videoFile={videoFile}
            // onRefresh={onRefresh}
            setVideoFile={(uri) => setVideoFile(uri)}
            profileImage={profileImage}
            forumId={parseInt(forumId, 10)}
            questionHubData={sendQuestion => questionHubData(sendQuestion)}
            userType={userType == 'student' ? 2 : 1}
            jwtToken={jwt}
          />
        }
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
        className="comment-content-popup"
      />
      <PopUpModal
        ref={commentRef}
        header="Comments"
        body={
          <DoubtComments
            parentUniqueCode={forumCode}
            parentForumId= {parseInt(forumId,10)}
            selectedQuestion={selectedQuestion}
            UniqueCode={commentQuestionCode}
            questionId={parseInt(questionId,10)}
          />
        }
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
        className="comment-content-popup"
        onRefresh={onRefresh}
      />
    </React.Fragment>
  );
}
